module.exports = __webpack_public_path__ + "img/Apps.845791f0.svg";